export const LBS_PER_TON = 2000; // 2000 lbs per ton

export const KGS_PER_TON = 907.185; // 907.185 kg per ton
